module.exports = __webpack_public_path__ + "img/bom2.f673c1ba.png";